import Vue from 'vue';
import store from './../../store';
import stockTransformer from './../../transformers/stock';
import helpers from '../../utils/helpers';

const success = ({ data }, resolve) => {
  const stocks = stockTransformer.fetchCollection(data.data);

  store.dispatch('FetchAllStocks', stocks);
  resolve(stocks);
};

const failed = () => {
};

export default (params = {}) => (
  new Promise((resolve, reject) => {
    Vue.$http.get(helpers.buildUrl('/stocks', params))
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/stock/all.js